import { render, staticRenderFns } from "./handlingMethod.vue?vue&type=template&id=ef99e3a6&scoped=true"
import script from "./handlingMethod.vue?vue&type=script&lang=js"
export * from "./handlingMethod.vue?vue&type=script&lang=js"
import style0 from "./handlingMethod.vue?vue&type=style&index=0&id=ef99e3a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef99e3a6",
  null
  
)

export default component.exports